"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const SidemenuItem = ({ linkTo, icon, label }) => (React.createElement(react_router_dom_1.NavLink, { to: linkTo, className: 'vf-nav-sidemenu-item padding-horizontal-2x flex flex-stretch', activeClassName: 'active' },
    React.createElement("i", { className: `vf-icon icon-${icon}` }),
    React.createElement("div", { className: 'vf-nav-sidemenu-item-label flex-1' }, label)));
exports.default = SidemenuItem;
